import { useEffect, useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const GalleryPage = () => {
  useEffect(() => {
    document.title = 'ギャラリー｜さかなの木';
  }, []);

  const [lightboxImage, setLightboxImage] = useState<string | null>(null);
  const [activeFilter, setActiveFilter] = useState<string>('all');

  const filters = [
    { id: 'all', label: 'すべて' },
    { id: 'food', label: '料理' },
    { id: 'interior', label: '店内' },
    { id: 'drink', label: 'お酒' },
  ];

  const galleryImages = [
    {
      src: 'https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/61ebe66436320857bc5cb67a57fd3f87.webp',
      caption: 'ランチ',
      category: 'food',
    },
    {
      src: 'https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/998cc9fdfc3e94f9198a40d52a19a6bf.webp',
      caption: '温かみのある店内',
      category: 'interior',
    },
    {
      src: 'https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/e58742966538d819c30edb2b96d9974d.webp',
      caption: '小皿',
      category: 'food',
    },
    {
      src: 'https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/82ed58ac8454e0294110c64cd63e77c4.webp',
      caption: '厳選日本酒',
      category: 'drink',
    },
    {
      src: 'https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/79d20a850aa3c3ca07881bb3b1205a14.webp',
      caption: '秋田県産野菜',
      category: 'food',
    },
    {
      src: 'https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/e2f7a91df5d7f77d10aed45c0e015a03.webp',
      caption: '1品',
      category: 'food',
    },
  ];

  const filteredImages = activeFilter === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === activeFilter);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="hero-section relative h-[60vh] md:h-[70vh] mt-20">
        <div className="hero-inner relative w-full h-full">
          <img
            className="hero-image absolute inset-0 w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/e2f7a91df5d7f77d10aed45c0e015a03.webp"
            alt="さかなの木 ギャラリー"
          />
          <div className="hero-overlay absolute inset-0 bg-gradient-to-b from-black/25 via-black/20 to-black/25"></div>
          <div className="hero-copy absolute inset-0 flex items-center justify-center text-center text-white px-4">
            <div>
              <h2 className="text-4xl md:text-6xl font-bold text-white">GALLERY</h2>
              <p className="text-lg md:text-xl mt-4 text-white">料理と店内の様子</p>
            </div>
          </div>
        </div>
      </section>
      <h1 className="text-center py-1 text-gray-500" style={{ fontSize: '10px', lineHeight: '1.2' }}>ギャラリー｜鵜の木で新鮮魚が味わえる海鮮居酒屋｜さかなの木</h1>

      {/* Filter Buttons */}
      <section className="sticky top-20 z-40 bg-white border-b border-gray-200 shadow-sm">
        <div className="container mx-auto px-4">
          <div className="flex gap-3 justify-center py-6">
            {filters.map((filter) => (
              <button
                key={filter.id}
                onClick={() => setActiveFilter(filter.id)}
                className={`px-6 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all cursor-pointer ${
                  activeFilter === filter.id
                    ? 'bg-primary text-white'
                    : 'bg-white text-accent border border-gray-300 hover:bg-gray-50'
                }`}
              >
                {filter.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-20 relative">
        <div className="absolute inset-0 w-full h-full">
          <img
            className="w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/0148398420e99339a69597ed7c6268b3.png"
            alt="背景"
          />
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="columns-1 md:columns-2 lg:columns-3 gap-6 max-w-7xl mx-auto">
            {filteredImages.map((image, index) => (
              <div
                key={index}
                className="break-inside-avoid mb-6 cursor-pointer group"
                onClick={() => setLightboxImage(image.src)}
              >
                <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all">
                  <div className="relative overflow-hidden">
                    <img
                      src={image.src}
                      alt={image.caption}
                      className="w-full h-auto object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                      <i className="ri-zoom-in-line text-white text-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
                    </div>
                  </div>
                  <div className="p-4">
                    <p className="text-center font-medium" style={{ color: '#3A3D3F' }}>{image.caption}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Instagram CTA */}
      <section className="py-20 relative">
        <div className="absolute inset-0 w-full h-full">
          <img
            className="w-full h-full object-cover object-center"
            src="https://static.readdy.ai/image/78304d8d02dcd7906feadaea6da56541/0148398420e99339a69597ed7c6268b3.png"
            alt="背景"
          />
        </div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <div className="max-w-3xl mx-auto">
            <div className="w-20 h-20 flex items-center justify-center bg-primary/10 rounded-full mx-auto mb-6">
              <i className="ri-instagram-line text-4xl text-primary"></i>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-accent mb-4">
              Instagramで毎日更新中
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              本日のメニューや店内の様子を毎日更新しています。<br />
              ぜひフォローして、最新情報をチェックしてください。
            </p>
            
            {/* Instagram Embed Widget */}
            <div className="max-w-xl mx-auto mb-8">
              <blockquote 
                className="instagram-media" 
                data-instgrm-permalink="https://www.instagram.com/sakananoki_unoki/?utm_source=ig_embed&amp;utm_campaign=loading" 
                data-instgrm-version="14"
                style={{
                  background: '#FFF',
                  border: 0,
                  borderRadius: '3px',
                  boxShadow: '0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15)',
                  margin: '1px auto',
                  maxWidth: '540px',
                  minWidth: '326px',
                  padding: 0,
                  width: 'calc(100% - 2px)'
                }}
              >
              </blockquote>
            </div>

            <a
              href="https://www.instagram.com/sakananoki_unoki/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full text-lg font-medium hover:from-purple-600 hover:to-pink-600 transition-all whitespace-nowrap cursor-pointer"
            >
              <i className="ri-instagram-line text-2xl"></i>
              <span>@sakananoki_unoki</span>
            </a>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightboxImage && (
        <div
          className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
          onClick={() => setLightboxImage(null)}
        >
          <button
            className="absolute top-4 right-4 w-12 h-12 flex items-center justify-center bg-white/10 rounded-full text-white hover:bg-white/20 transition-colors cursor-pointer"
            onClick={() => setLightboxImage(null)}
          >
            <i className="ri-close-line text-2xl"></i>
          </button>
          <img
            src={lightboxImage}
            alt="拡大表示"
            className="max-w-full max-h-full object-contain"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}

      <Footer />
    </div>
  );
};

export default GalleryPage;
